import { createContext, useContext, useEffect, useState } from "react";
import usaConfig from "./generated/usa.config";
import globalConfig from "./generated/global.config";
import { detectRegion, storeRegion } from "./detectRegion";

const configs = { usa: usaConfig, global: globalConfig };

const RegionContext = createContext({
  region: "global",
  config: globalConfig,
  source: "default",
  setRegion: () => {},
});

export function RegionProvider({ children }) {
  // Render immediately with the global edition; detection upgrades the
  // region without blocking first paint (no redirect, no loop, same URL).
  const [state, setState] = useState({ region: "global", source: "default" });

  useEffect(() => {
    let cancelled = false;
    detectRegion().then(({ region, source }) => {
      if (!cancelled) setState({ region, source });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const setRegion = (region) => {
    if (!configs[region]) return;
    storeRegion(region);
    setState({ region, source: "manual" });
  };

  const value = {
    region: state.region,
    source: state.source,
    config: configs[state.region] || globalConfig,
    setRegion,
  };

  return (
    <RegionContext.Provider value={value}>{children}</RegionContext.Provider>
  );
}

export function useRegion() {
  return useContext(RegionContext);
}
